<script>
export default {
  methods: {
    tel_open(phone) {
      if(false && window.plugins && window.plugins.CallNumber) {
        window.plugins.CallNumber.callNumber(
            function () {

            },
            function (err) {

            },
            phone
        );
      }
      else if(window.cordova && window.cordova.InAppBrowser){
        let browser = window.cordova.InAppBrowser.open('tel:'+phone, "_target", 'location=no');
        setTimeout(function () {
          browser.close()
        }, 1000)
      }
      else {
        let mywindow = window.open('tel:' + phone, '_system');
        setTimeout(function () {
          mywindow.close()
        }, 1000)
      }
    },
    email_open(email) {
      if(window.cordova && window.cordova.InAppBrowser){
        let browser = window.cordova.InAppBrowser.open('mailto:'+email, "_target", 'location=no');
        setTimeout(function () {
          browser.close()
        }, 1000)
      }
      else {
        let mywindow = window.open('mailto:' + email, '_system');
        setTimeout(function () {
          mywindow.close()
        }, 1000)
      }
    },
    link_open(value) {

    }
  }
}
</script>